/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const LineItem = core.serialization.object({
    price: core.serialization.string(),
    quantity: core.serialization.number(),
});
